// 搜索
const searchIndex = () => import('@/pages/search/index.vue');
export default [
  {
    path: '/search',
    component: searchIndex,
    meta: {
      title: '搜索',
    },
  },
];
